<a id="skip-link" class="skip-link" href="#main-content" (click)="skipToMainContent($event)">
  {{ 'common.skip-to-main-content' | translate }}
</a>

@if (allowLoader() && showLoader()) {
  <motif-progress-loader [show]="true" [fullScreen]="true"></motif-progress-loader>
} @else {
  <motif-theme [variant]="themeVariant()"></motif-theme>
  <router-outlet />
}
